// 引入项目封装的axios请求实例（若你的项目封装文件名不同，请对应修改）
import service from '@/api/index';

/**
 * 获取菜单列表（GET /menu/list）
 * @param {Object} params - 查询参数（对应接口文档中的query参数）
 * @returns {Promise}
 */
export function listMenu(params) {
  return service({
    url: '/system/menu/list',
    method: 'get',
    params: params
  });
}

/**
 * 根据菜单编号获取详细信息（GET /menu/{menuId}）
 * @param {Number|String} menuId - 菜单ID（路径参数）
 * @returns {Promise}
 */
export function getMenu(menuId) {
  return service({
    url: `/system/menu/${menuId}`,
    method: 'get'
  });
}

/**
 * 新增菜单（POST /menu）
 * @param {Object} menu - 菜单数据（请求体，对应接口文档中的menu对象）
 * @returns {Promise}
 */
export function addMenu(menu) {
  return service({
    url: '/system/menu',
    method: 'post',
    data: menu
  });
}

/**
 * 修改菜单（PUT /menu）
 * @param {Object} menu - 菜单数据（请求体，含menuId主键）
 * @returns {Promise}
 */
export function updateMenu(menu) {
  return service({
    url: '/system/menu',
    method: 'put',
    data: menu
  });
}

/**
 * 删除菜单（DELETE /menu/{menuId}）
 * @param {Number|String} menuId - 菜单ID（路径参数）
 * @returns {Promise}
 */
export function delMenu(menuId) {
  return service({
    url: `/system/menu/${menuId}`,
    method: 'delete'
  });
}

/**
 * 获取路由信息（GET /menu/getRouters）
 * @returns {Promise}
 */
export function getRouters() {
  return service({
    url: '/system/menu/getRouters',
    method: 'get'
  });
}

/**
 * 获取菜单下拉树列表（GET /menu/treeselect）
 * @param {Object} params - 可选查询参数
 * @returns {Promise}
 */
export function getMenuTreeselect(params) {
  return service({
    url: '/system/menu/treeselect',
    method: 'get',
    params: params || {}
  });
}

/**
 * 加载对应角色菜单列表树（GET /menu/roleMenuTreeselect/{roleId}）
 * @param {Number|String} roleId - 角色ID
 * @returns {Promise}
 */
export function getRoleMenuTreeselect(roleId) {
  return service({
    url: `/system/menu/roleMenuTreeselect/${roleId}`,
    method: 'get'
  });
}

//获取菜单下拉树列表
export const treeselect = (params) => {
  return service({
    url: '/system/menu/treeselect',
    method: 'get',
    params
  })
}

//加载对应角色菜单列表树
export const roleMenuTreeselect = (roleId) => {
  return service({
    url: `/system/menu/roleMenuTreeselect/${roleId}`,
    method: 'get'
  })
}
